export default "__VITE_ASSET__CthwkiaF__"